<div class="content" [formGroup]="form" *ngIf="'change-password.repeat-password' | translate">
  <div class="header link" [routerLink]="['/']">
    <img src="assets/images/logo-upperleft.png" class="logo-image" alt="Logo" />
    <div class="logo-title">
      {{ 'app.service_portal' | translate }}
    </div>
  </div>
  <!-- <div class="background-text">
    <p class="para-one">{{ 'home.message.para_one' | translate }}</p>
    <p class="para-two">{{ 'home.message.para_two' | translate }}</p>
  </div> -->
  <div class="form-box-container row">
    <div class="form-box">
      <div class="">
        <div class="header">
          <h3>{{ 'reset-password.header' | translate }}</h3>
          <select (change)="selectLanguage($event.target.value)" [value]="netzTranslateService.getCurrentLang()">
            <option *ngFor="let o of languageOptions" [value]="o">{{ o }}</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div>
          <input
            [value]="form.controls.email.value"
            [disabled]="true"
            [placeholder]="'change-password.email' | translate"
            class="ui-input pInputText input-field-width"
            pInputText
            readonly
            size="30"
            type="text" />
        </div>
      </div>

      <div class="row">
        <div>
          <input
            id="password-input-new-value"
            type="password"
            size="30"
            pPassword
            [placeholder]="'change-password.new-password' | translate"
            [showPassword]="showPasswordTwo"
            class="ui-input"
            formControlName="password"
            [feedback]="false" />
          <span class="show-password-container">
            <i [ngClass]="showPasswordTwo ? 'pi pi-eye-slash' : 'pi pi-eye'" (click)="showPasswordTwo = !showPasswordTwo"></i>
          </span>
        </div>
      </div>

      <div class="row">
        <div>
          <input
            id="password-input-repeat-value"
            type="password"
            size="30"
            pPassword
            [placeholder]="'change-password.repeat-password' | translate"
            [showPassword]="showPasswordThree"
            class="ui-input pInputText input-field-width"
            formControlName="repeatPassword"
            [feedback]="false" />
          <span class="show-password-container">
            <i [ngClass]="showPasswordThree ? 'pi pi-eye-slash' : 'pi pi-eye'" (click)="showPasswordThree = !showPasswordThree"></i>
          </span>
        </div>
      </div>

      <div class="row buttons-row">
        <button
          pButton
          type="button"
          class="cancel-button"
          id="password-btn-cancel"
          label="{{ 'change-password.cancel-button-label' | translate }}"
          (click)="cancel()"
          [disabled]="form.pristine"></button>

        <button
          pButton
          type="button"
          class="register-button"
          id="password-btn-submit"
          label="{{ 'change-password.submit-button-label' | translate }}"
          (click)="save()"
          [disabled]="!form.valid"></button>
      </div>

      <div class="row" *ngIf="errors">
        <div *ngFor="let error of errors" class="error-message">{{ error | translate }}</div>
      </div>
    </div>
  </div>
</div>
